<template>
  <div class="study-pkg">
    <div class="scroll-wraper" ref="scrollWrapper">
      <img :src="bannerImg" alt="" class="banner-img"  ref="bannerImg">
      <div class="tab" ref="tab">
        <p v-for="(tab, index) in tabBar" :key="index" @click="changeSwiper(index)" :class="{'active': currentSwiperIndex===index}">{{tab}}</p>
      </div>
      <div class="wrapper" v-show="currentSwiperIndex===0">
        <div class="detail">
          <div class="guide">
            <h3 class="title">家长指引</h3>
            <p class="text">{{specialDetial.description}}</p>
            <img :src="specialDetial.displayDetailPhoto" alt="" class="guide-img">
          </div>
          <div class="study" v-if="albumPage.length">
            <h3 class="title">{{albumPage[0]?albumPage[0].name:''}}</h3>
            <cell v-for="(media, index1) in albumPage[0].mediaList" :key="media.id" :cellData="media" v-if="index1<3" @toListen="toListen"></cell>
            <div class="view-more">
              <div class="content">
                <span @click="changeSwiper(1)">查看更多故事~</span>
                <img src="/images/study_more.png" alt="">
              </div>
            </div>
          </div>
          <div class="explain">
            <h3 class="title">使用说明</h3>
            <p class="content">{{specialDetial.remarks}}</p>
          </div>
        </div>
      </div>
      <div v-show="currentSwiperIndex===1" class="wrapper">
        <div class="directory" v-for="(album, index) in albumPage" :key="album.id" ref="directory">
          <h3 
            :class="['title', {'active': album.show}]"
            @click="changeDirectory(index, album.id)"
            ref="scrollTargets"
          >{{album.name}}</h3>
          <div class="directory-content" v-show="album.show">
            <cell v-for="media in album.mediaList" :key="media.id" :cellData="media" @toListen="toListen"></cell>
          </div>
        </div>
      </div>
    </div>
    <div class="tab stick-tab" ref="stickTab" :class="{'stick-tab-show': showStickTab}">
      <p v-for="(tab, index) in tabBar" :key="index" @click="changeSwiper(index)" :class="{'active': currentSwiperIndex===index}">{{tab}}</p>
    </div>
    <bottom-bar :albumData="{status: 0}" @toNext="bottomBarHandler"></bottom-bar>
    <cus-share v-show="shareShow" @cancel="shareShow=false"></cus-share>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {BottomBar, Cell} from '@/components/goods'
import {swiper, swiperSlide} from "vue-awesome-swiper";
import { setTimeout } from 'timers';
const tabBar = ['详情', '目录']
const SESSION_KEYS = {
  SWIPER_INDEX: 'zibStudyPkgSwiperIndex',
  MEDIA_INDEX: 'zibStudyPkgMediaIndex'
}
export default {
  components: {
    BottomBar,
    Cell,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      currentSwiperIndex: 0,
      tabBar,
      scrollEvents: ['scroll'],
      correlationId: '',
      specialDetial: {},
      albumPage: [],
      currentAlbumId: null,
      loadingShow: false,
      goodsNum: '20190530142427007908851',
      shareShow: false,
      showStickTab: false
    };
  },
  watch: {
    correlationId: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.getAlbumPage(val)
          this.getSpecialDetail(val)
        }
      }
    },
    currentAlbumId: {
      immediate: true,
      handler: function (albumId) {
        if (albumId) {
          let index = this.albumPage.findIndex(item => item.id === albumId)
          if (index > -1) {
            if (this.albumPage[index].mediaList && this.albumPage[index].mediaList.length) return
            this.getMediaPage(albumId)
            if (this.currentSwiperIndex === 1) {
              this.getMediaPage(this.albumPage[0].id)
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isPlusMember: "auth/isPlusMember",
    }),
    settledHeight () {
      return this.$refs.tab.offsetTop + this.$refs.directory[0].offsetTop
    },
    scrollTargets () {
      return  this.$refs.scrollTargets
    },
    bannerImg () {
      return this.specialDetial.displayBigPhoto ? this.specialDetial.displayBigPhoto : '/images/learning-anywhere.png'
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.fullPath === '/') {
        sessionStorage.setItem(SESSION_KEYS[SWIPER_INDEX], 0)
        sessionStorage.setItem(SESSION_KEYS[MEDIA_INDEX], 0)
      }
    })
  },
  created () {
    this.getCorrelationId()
  },
  mounted () {
    this.$nextTick(() => {
      let top = this.$refs.tab.offsetTop
      window.addEventListener('scroll', () => {
        let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
        if (scrollTop < top) {
          this.showStickTab = false
        } else {
          this.showStickTab = true
        }
      })
    })
  },
  methods: {
    getCorrelationId () {
      this.$api.payment_v1_goods_app_goodsNum_get({
        path: {
          goodsNum: this.goodsNum
        }
      })
      .then(e => {
        if (!e || !e.correlationId) {
          return
        }
        if (e.correlationId) {
          this.correlationId = e.correlationId
          if (sessionStorage.getItem(SESSION_KEYS[SWIPER_INDEX])) {
            this.currentSwiperIndex = parseInt(sessionStorage.getItem(SESSION_KEYS[SWIPER_INDEX]))
          }
        }
      })
    },
    // 获取专题详情
    getSpecialDetail (correlationId) {
      this.$api.api_v3_album_get({
        params: {
          id: correlationId
        }
      })
      .then(e => {
        if (!e || !e.album) {
          return
        }
        this.specialDetial = e.album
      })
    },
    // 获取专辑
    getAlbumPage (correlationId) {
      this.$api.api_v3_albumPage_get({
        params: {
          parentId: correlationId,
          type: 0,
          orders: 'updateDate desc'
        }
      })
      .then(e => {
        if (!e || !e.albumPage || !e.albumPage.content || !e.albumPage.content.length) {
          return
        }
        e.albumPage.content.map((item, index) => {
          item.show = false
        })
        this.albumPage = e.albumPage.content
        let mediaIndex = parseInt(sessionStorage.getItem(SESSION_KEYS[MEDIA_INDEX]))
        this.albumPage[mediaIndex].show = true
        this.currentAlbumId = this.albumPage[mediaIndex].id
      })
    },
    // 获取音频
    getMediaPage (currentAlbumId) {
      this.$api.api_v3_mediaPage_get({
        params: {
          albumId: currentAlbumId,
          status: 2
        }
      })
      .then(e => {
        if (!e || !e.mediaPage || !e.mediaPage.content || !e.mediaPage.content.length) {
          return
        }
        let index = this.albumPage.findIndex(item => item.id === currentAlbumId)
        this.$set(this.albumPage[index], 'mediaList', e.mediaPage.content)
      })
    },
    changeDirectory(currentIndex, albumId) {
      this.currentAlbumId = albumId
      sessionStorage.setItem(SESSION_KEYS[MEDIA_INDEX], currentIndex)
      this.albumPage.map((element,index) => {
        if (currentIndex === index) {
          this.$set(element, 'show', !element.show)
        } else {
          this.$set(element, 'show', false)
        }
      })
      let distance = 0
      if (this.albumPage[currentIndex] && this.albumPage[currentIndex].show) {
        for (let i = 0;i< this.scrollTargets.length; i++) {
          if (i >= currentIndex) {
            break
          }
          distance += this.scrollTargets[i].offsetHeight
        }
        distance = distance + this.settledHeight
        setTimeout(() => {
          window.scrollTo({
            top: distance, 
            behavior: "smooth" 
          })
        }, 300)
      }
    },
    changeSwiper (index) {
      this.currentSwiperIndex = index
      sessionStorage.setItem(SESSION_KEYS[SWIPER_INDEX], index)
    },
    toListen (media) {
      if (!media.trial) {
        this.$createToast({
          txt: "当前专辑需要购买后才能收听哦～",
          type: "txt"
        }).show();
        return
      }
      this.$router.push({
        name: "player",
        params:{
          id: media.mediaId,
        },
        query: {
          albumId: this.currentAlbumId,
        }
      });
    },
    bottomBarHandler (nextParams) {
      if (nextParams === 'toShareBtnUrl') {
        if (this.isPlusMember) {
          this.shareShow = true
          return
        }
        if (!this.albumPage || !this.albumPage.length || !this.albumPage[0].mediaList || !this.albumPage[0].mediaList.length) return
        let mediaList = this.albumPage[0].mediaList
        let index = mediaList.findIndex(item => item.trial)
        if (index > -1) {
          let mediaId = mediaList[index].id
          this.$router.push({
            name: "player",
            params:{
              id: mediaId
            },
            query: {
              albumId: this.albumPage[0].id,
            }
          });
        }
      } else if (nextParams === 'toBuy') {
        // console.log('4.1版本购买流程')
        this.$router.push(`/goods/checkoutPkg/${this.goodsNum}`)
      }
    }
  }
};
</script>
<style scoped>
.study-pkg{
  height: 100%;
  font-size: 0;
}
.scroll-wraper{
  padding-bottom: 53px;
}
.banner-img{
  width: 100%;
  height: 375px;
}
.tab{
  width: 100%;
  height: 45px;
  display: flex;
  background: #fff;
  border-bottom: 1px solid #F4F5F7;
}
.stick-tab{
  opacity: 0;
  position: fixed;
  top: 0;
  bottom: auto;
}
.stick-tab-show{
  opacity: 1;
  z-index: 2;
}
.tab>p{
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight:800;
  color: #999999;
  font-size: 16px;
  opacity: 1;
}
.tab>p.active{
  color: #3F8DFD;
  position: relative;
}
.tab>p.active::after{
  content: '';
  width:20px;
  height:4px;
  background:rgba(63,141,253,1);
  border-radius:2px;
  position: absolute;
  bottom: 0;
}
.wrapper{
  width: 100%;
  box-sizing: border-box;
  padding: 15px 20px;
  background-color: #F0FEFF;
  position: relative;
  z-index: 1;
}
.detail, .directory{
  box-sizing: border-box;
  padding: 0 20px 20px 20px;
  background-color: #fff;
}
.directory{
  padding-bottom: 0;
  overflow: hidden;
  transition: height 0.3s;
}
.directory .title{
  border-bottom: 1px solid #F0FEFF;
  position: relative;
}
h3.title{
  height:60px;
  font-size:20px;
  font-weight:bold;
  color:#333333;
  line-height:60px;
}
.directory .title::after{
  content: '';
  width: 13px;
  height: 7px;
  background: url('/images/study_arrow.png') no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  transform: rotate(180deg);
  transition: transform 0.5s;
}
.directory .active.title::after{
  background: url('/images/study_arrow.png') no-repeat;
  transform: rotate(0);
  transition: transform 0.5s;
}
.guide .text{
  font-size: 12px;
  font-weight: 400;
  color:rgba(102,102,102,1);
  line-height: 22px;
  overflow: hidden; 
  text-overflow: ellipsis;
  display: -webkit-box; 
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.guide-img{
  margin-top: 20px;
  width: 100%;
}
.view-more{
  text-align: center;
  margin-top: 16px;
}
.view-more .content{
  display: inline-block;
  padding: 3px 8px;
  background:#EBF3FE;
  border-radius:12px;
  height: 17px;
  line-height: 17px;
}
.view-more .content>span{
  margin-right: 4px;
  font-size:12px;
  color:rgba(63,141,253,1);
  vertical-align: middle;
}
.view-more .content>img{
  vertical-align: middle;
  width: 14px;
}
.explain .content{
  font-size:12px;
  line-height:22px;
  font-weight:400;
  color:#666;
}
.study-pkg >>> .sticky{
  border-top: 1px solid #F2F2F2;
  z-index: 2;
}
.study-pkg  >>> .share{
  background: #fff;
  color: #5292FF;
  font-size:16px;
  font-weight:bold;
}
.study-pkg  >>> .buy{
  background: #5292FF;
  color: #fff;
  font-size:16px;
  font-weight:bold;
}
</style>

